import { useSyncExternalStore } from 'react';
import {
  subscribeSnapshotProgress,
  getSnapshotProgress,
  type SnapshotProgress,
} from '../services/snapshot';

/** Прогресс загрузки снапшота каталога (см. services/snapshot.ts). */
export function useSnapshotProgress(): SnapshotProgress {
  return useSyncExternalStore(subscribeSnapshotProgress, getSnapshotProgress);
}
